import React, {useEffect, useState} from "react"
import { graphql, useStaticQuery } from 'gatsby'
import {Tracking, TrackingProvider} from 'ak-react-utils'
import OrganisationComponent from 'organisation_component'
import CatalogOrderComponent from 'catalog_order_component'

const AkOrganisations = (props) => {

  const [referrer,setReferrer] = useState()

  useEffect(() => {
    setReferrer(window.location.href)
  }, [])

  const filterConfig = JSON.parse(props.component_config)
  const businessArea = 'schueleraustausch'
  const orgaLinkPrefix = '/organisation/'

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          crmApiUrl
          crmApiToken
          orderApiUrl
          orderApiToken
          scholarshipApiUrl
          ratingApiUrl
          tracking {
            mtUrl
            mtId
          }
        }
      }
    }
  `)

  const cfg = data.site.siteMetadata

  const tracker = new Tracking({enabled: true, gaId: null, mtId: cfg.tracking.mtId, mtUrl: cfg.tracking.mtUrl, debug: false})

  return (
    <TrackingProvider tracker={tracker}>
      <OrganisationComponent
        businessArea={businessArea}
        crmApiUrl={cfg.crmApiUrl}
        crmApiToken={cfg.crmApiToken}
        ratingApiUrl={cfg.ratingApiUrl}
        organisationLinkPrefix={orgaLinkPrefix}
        filter={filterConfig}
      >
        {({selectedOrganisation, onFinish}) => (
          <CatalogOrderComponent
            apiUrl={cfg.orderApiUrl}
            apiToken={cfg.orderApiToken}
            crmApiUrl={cfg.crmApiUrl}
            crmApiToken={cfg.crmApiToken}
            businessArea={businessArea}
            referrer={referrer}
            onFinish={onFinish}
            organisationId={selectedOrganisation.slug}
            upsell={true}
            upsellPrechecked={true}
          />
        )}
      </OrganisationComponent>
    </TrackingProvider>
  )
}

export default AkOrganisations
